import AppBar from 'material-ui/AppBar';
import Drawer from 'material-ui/Drawer';
import IconButton from 'material-ui/IconButton';
import { ListItem } from 'material-ui/List';
import ActionEventSeat from 'material-ui/svg-icons/action/event-seat';
import EntretiensIcon from 'material-ui/svg-icons/action/group-work';
import ExprerienceProIcon from 'material-ui/svg-icons/action/work';
import CommencerEntretiensIcon from 'material-ui/svg-icons/av/fast-forward';
import SynthesePlanActionIcon from 'material-ui/svg-icons/av/playlist-add-check';
import BibCompetencesIcon from 'material-ui/svg-icons/content/archive';
import EditionGeneraleIcon from 'material-ui/svg-icons/editor/format-list-bulleted';
import ModifierSalarieIcon from 'material-ui/svg-icons/editor/mode-edit';
import ConsulterEntretienIcon from 'material-ui/svg-icons/image/picture-as-pdf';
import NavigationClose from 'material-ui/svg-icons/navigation/close';
import ConvoquerSalarieIcon from 'material-ui/svg-icons/notification/event-available';
import EntrepriseIcon from 'material-ui/svg-icons/social/domain';
import SalariesIcon from 'material-ui/svg-icons/social/group';
import EtatDesLieuxSalarieIcon from 'material-ui/svg-icons/social/person';
import AjouterSalarieIcon from 'material-ui/svg-icons/social/person-add';
import FormationsIcon from 'material-ui/svg-icons/social/school';
import React from 'react';
import { connect } from "react-redux";
import { closeDrawer } from "../../actions/shared/actions_shared_1";
import config from './../../config';

class EntrepriseDrawer extends React.Component {

    constructor(props) {
        super(props);
        this.handleNestedListToggle = this.handleNestedListToggle.bind(this);
    }

    handleNestedListToggle(element) {
        element.open = !element.open;
    }

    render() {
        const first_salarie_id = this.props.salaries.length > 0 ? this.props.salaries[0].id : '';
        return (
            <div>
                <Drawer
                    open={this.props.open}
                    docked={false}
                    onRequestChange={() => this.props.dispatch(closeDrawer())}
                >
                    <AppBar
                        iconElementRight={<IconButton><NavigationClose /></IconButton>}
                        onRightIconButtonClick={() => this.props.dispatch(closeDrawer())}
                        iconElementLeft={this.props.entrepriseID ?
                            <img alt='logo'
                                style={{ height: '48px', cursor: 'pointer' }}
                                onClick={() => this.props.history.push('/entreprise/')}
                                src={config.upload_path + this.props.logo + '?randomToken=' + this.props.logoRandomToken} />
                            : null}
                    />
                    <ListItem
                        key={1}
                        primaryText="Entreprise"
                        leftIcon={<EntrepriseIcon />}
                        primaryTogglesNestedList={true}
                        onNestedListToggle={this.handleNestedListToggle}
                        nestedItems={[
                            <ListItem key={1}
                                primaryText="Édition générale"
                                onClick={() => this.props.history.push('/entreprise/edition_generale')}
                                leftIcon={<EditionGeneraleIcon />} />,
                            <ListItem key={2}
                                primaryText="Synthèse des plans d'actions"
                                onClick={() => this.props.history.push('/entreprise/synthese')}
                                leftIcon={<SynthesePlanActionIcon />} />,
                            <ListItem key={3}
                                primaryText="Postes disponibles"
                                onClick={() => this.props.history.push('/entreprise/postes_disponibles')}
                                leftIcon={<ActionEventSeat />} />,
                            <ListItem key={4}
                                primaryText="Bibliotheque des compétences"
                                onClick={() => this.props.history.push('/entreprise/bibliotheque-des-competences')}
                                leftIcon={<BibCompetencesIcon />} />,
                        ]}
                    />
                    <ListItem
                        key={2}
                        primaryText="Salariés"
                        leftIcon={<SalariesIcon />}
                        primaryTogglesNestedList={true}
                        onNestedListToggle={this.handleNestedListToggle}
                        nestedItems={[
                            <ListItem key={1}
                                primaryText="Ajouter des salariés"
                                onClick={() => this.props.history.push('/entreprise/ajouter_des_salaries')}
                                leftIcon={<AjouterSalarieIcon />} />,

                            <ListItem key={2}
                                primaryText="Modifier un salarié"
                                onClick={() => this.props.history.push('/entreprise/modifier_un_salarie')}
                                leftIcon={<ModifierSalarieIcon />} />,
                            <ListItem key={3}
                                primaryText="Expériences profesionelles"
                                onClick={() => this.props.history.push('/entreprise/experiences_pro_salarie')}
                                leftIcon={<ExprerienceProIcon />} />,
                            <ListItem
                                key={4}
                                primaryText="Formations"
                                onClick={() => this.props.history.push('/entreprise/formations')}
                                leftIcon={<FormationsIcon />}
                            />,
                            <ListItem key={5}
                                primaryText="Convoquer un salarié"
                                onClick={() => this.props.history.push('/entreprise/convoquer_un_salarie/' + first_salarie_id)}
                                leftIcon={<ConvoquerSalarieIcon />} />,
                            <ListItem key={6}
                                primaryText="État des lieux par salarié"
                                onClick={() => this.props.history.push('/entreprise/etat_des_lieux')}
                                leftIcon={<EtatDesLieuxSalarieIcon />} />,
                        ]}
                    />
                    <ListItem
                        key={3}
                        primaryText="Entretiens"
                        leftIcon={<EntretiensIcon />}
                        primaryTogglesNestedList={true}
                        onNestedListToggle={this.handleNestedListToggle}
                        nestedItems={[
                            <ListItem key={1}
                                primaryText="Commencer un entretien"
                                onClick={() => this.props.history.push('/entreprise/passer_entretien')}
                                leftIcon={<CommencerEntretiensIcon />} />,
                            <ListItem key={2}
                                primaryText="Consulter une fiche d'entretien"
                                onClick={() => this.props.history.push('/entreprise/consulter_entretien')}
                                leftIcon={<ConsulterEntretienIcon />} />,
                        ]}
                    />
                </Drawer>
            </div>
        );
    }
}

function mapStateToProps(store) {
    return {
        open: store.shared.drawer.open,
        entrepriseID: store.entreprise.entreprise_infos.id,
        logoRandomToken: store.entreprise.entreprise_infos.logoRandomToken,
        logo: store.entreprise.entreprise_infos.logo,
        salaries: store.entreprise.entreprise_infos.salaries
    }
}

export default connect(mapStateToProps)(EntrepriseDrawer);


// WEBPACK FOOTER //
// ./src/components/entreprise/EntrepriseDrawer.js